//封装本地存取token
const key='token-key'

//存
const setToken=(token)=>{
    return window.localStorage.setItem(key,token)
}

//取
const getToken=()=>{
    return window.localStorage.getItem(key)
}
//删除
const removeToken=()=>{
    return window.localStorage.removeItem(key)
}


export {
    setToken,
    getToken,
    removeToken
}